module.exports = __webpack_public_path__ + "static/media/armageddon.d0fadf57.jfif";